"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaper = getPaper;
const svg_js_1 = require("@svgdotjs/svg.js");
const svgdom_1 = __importDefault(require("svgdom"));
const document = svgdom_1.default.document;
(0, svg_js_1.registerWindow)(svgdom_1.default, document);
function getPaper() {
    // eslint-disable-next-line new-cap
    return (0, svg_js_1.SVG)(document.documentElement);
}
//# sourceMappingURL=getPaper.js.map